import React from "react";
import { StarsBackground } from "@/components/StarsBackground";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Pricing from "@/components/Pricing";
import Clips from "@/components/Clips";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative min-h-screen" data-testid="home-page">
      <StarsBackground />
      <Header />
      <main className="relative z-10">
        <Hero />
        <Pricing />
        <Clips />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
